/**
 * @generated SignedSource<<78b1950912817db337df5821aa2ec034>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useToggleWatchCompany_Mutation$variables = {
  companySlug: string;
};
export type useToggleWatchCompany_Mutation$data = {
  readonly toggleWatchCompany: {
    readonly company: {
      readonly watching: boolean | null;
    } | null;
  } | null;
};
export type useToggleWatchCompany_Mutation = {
  response: useToggleWatchCompany_Mutation$data;
  variables: useToggleWatchCompany_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companySlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "companySlug",
    "variableName": "companySlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "watching",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useToggleWatchCompany_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleWatchCompanyMutation",
        "kind": "LinkedField",
        "name": "toggleWatchCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNode",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useToggleWatchCompany_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleWatchCompanyMutation",
        "kind": "LinkedField",
        "name": "toggleWatchCompany",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyNode",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75909ef8b43acb40baa3bbb685ac6d57",
    "id": null,
    "metadata": {},
    "name": "useToggleWatchCompany_Mutation",
    "operationKind": "mutation",
    "text": "mutation useToggleWatchCompany_Mutation(\n  $companySlug: String!\n) {\n  toggleWatchCompany(companySlug: $companySlug) {\n    company {\n      watching\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5046ad96d604f436ac9cc3fc3f7881f9";

export default node;
